import React, { useContext } from 'react';

import { ShopTemplateContext as IShopTemplateContext, useShopTemplateContextInternal } from './UseShopTemplateContext';

const initialContext: IShopTemplateContext = {
  canShowPricing: false,
  hasPromotion: false,
  promotion: {
    isFromUrl: false,
  },
  rates: undefined,
  plans: undefined,
  reseller: undefined,
};

const ShopTemplateContext = React.createContext<IShopTemplateContext>(initialContext);
ShopTemplateContext.displayName = 'ShopTemplateContext';

export const useShopTemplateContext = () => useContext(ShopTemplateContext);

export const ShopTemplateContextProvider: React.FC = ({ children }) => {
  return (
    <ShopTemplateContext.Provider value={useShopTemplateContextInternal()}>
      {children}
    </ShopTemplateContext.Provider>
  );
};

export const ShopTemplateContextConsumer = ShopTemplateContext.Consumer;
